<div>
<h2 i18n="Assessment information">HEADING_ASSESSMENT_INFO</h2>
<p i18n="Please enter the following information for your assessment."
>PARA_ACTION_COMPLETE_ASSESSMENT</p>
    <!-- formGroup="profileForm" -->
    <form [formGroup]="profileForm" (ngSubmit)="onSubmit()">
      <div class="form-group">
        <label
          for="title"
          i18n="Name of this assessment">LABEL_ASSESSMENT_NAME</label>
        <input
          type="text"
          formControlName="title"
          class="form-control assessmenttitle"
          placeholder="Name of this assessment"
          >
        <div class="title error alert alert-danger d-none"></div>
        <small
          class="form-text text-muted"
          i18n="This is the name used to refer to this assessment."
        >TEXT_ASSESSMENT_NAME_PURPOSE</small>
      </div>
      <div class="form-group">
        <label
          for="uref"
          i18n="User reference">LABEL_USER_REFERENCE</label>
        <input
          type="text"
          formControlName="uref"
          class="form-control uref"
          placeholder="Your reference"
          >
        <div class="uref error alert alert-danger d-none"></div>
        <small
          class="form-text text-muted"
          i18n="This is the user reference for this assessment"
        >TEXT_USER_REFERENCE</small>
      </div>
      <div class="form-group">
        <label
          for="description"
          i18n="Description">LABEL_DESCRIPTION</label>
        <textarea
          type="text"
          formControlName="description"
          class="form-control uref"
          placeholder="Description"
          ></textarea>
        <div class="description error alert alert-danger d-none"></div>
        <small
          class="form-text text-muted"
          i18n="Description and any notes about this assessment."
        >TEXT_ASSESSMENT_USER_DESCRIPTION</small>
      </div>
      <div [ngClass]="{
        'd-none': roughcheck.status_email === 0,
        'form-group': roughcheck.status_email > 0
        }">
        <label
          for="email"
          i18n="Email">LABEL_EMAIL</label>
        <input
          type="email"
          formControlName="email"
          class="form-control email"
          placeholder="email@example.com"
          >
        <div *ngIf="profileForm.controls['email'].invalid && (profileForm.controls['email'].dirty || profileForm.controls['email'].touched)"
          class="alert alert-danger">
          <div *ngIf="profileForm.controls['email'].errors.required">
            Please enter your email address
          </div>
          <div *ngIf="profileForm.controls['email'].errors.email">
            Please check your email address
          </div>
        </div>
        <div class="email error alert alert-danger d-none"></div>
        <small
          class="form-text text-muted"
          i18n="This is the user reference for this assessment"
        >TEXT_ASSESSMENT_EMAIL_PURPOSE</small>
      </div>

      <button
        type="submit"
        [disabled]="!profileForm.valid"
        class="btn btn-primary float-end"
        i18n="Next">BUTTON_NEXT</button>
      <button
        type="submit"
        (click)="onGoBack()"
        class="btn btn-secondary"
        i18n="Previous">BUTTON_PREVIOUS</button>

    </form>
</div>
